<ion-header>
  <ion-toolbar mode="ios">
    <ion-title text-center> Select Pickup Executive </ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="closeModal()">
        <ion-icon
          class="position-rule"
          slot="icon-only"
          name="close-circle"
        ></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content>
  <ion-grid *ngIf="pickupPersons && pickupPersons?.length > 0">
    <ion-row
      *ngFor="let person of pickupPersons"
      (click)="setPickupPerson(person)"
    >
      <ion-col size="12">
        <ion-item lines="none" color="light" class="my-item">
          <ion-col size="12">
            <ion-text font-bold text-regular="" color="dark">
              {{ person?.userName }}
            </ion-text>
            <br />
            <ion-text font-regular="" text-regular="" color="medium">
              {{ person?.mobileNumber }}
            </ion-text>
          </ion-col>
          <ion-icon
            class="icon-color"
            name="radio-button-off"
            slot="end"
            [hidden]="assignedPersonId === person?.id"
          ></ion-icon>
          <ion-icon
            name="checkmark-circle"
            slot="end"
            color="primary"
            [hidden]="assignedPersonId != person?.id"
          ></ion-icon>
        </ion-item>
      </ion-col>
    </ion-row>
  </ion-grid>
  <ion-grid *ngIf="pickupPersons?.length === 0">
    <ion-row>
      <ion-col size="12" class="ion-text-center">
        <ion-text color="dark" class="text-medium font-medium"
          >There are no pickup executives</ion-text
        >
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>
<ion-footer no-box-shadow>
  <ion-grid>
    <ion-row>
      <ion-col size="12">
        <ion-button
          centered=""
          [disabled]="!selectedPersonId"
          (click)="submit()"
          recykal-button=""
          size="large"
          expand="block"
          color="primary"
        >
          Done
        </ion-button>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-footer>
